import React from 'react'

const ArrowCaretDownIcon = ({ width = '16', height = '16', fill="none",...props }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_4884_29)">
        <path d="M7.99999 8.78145L11.3 5.48145L12.2427 6.42411L7.99999 10.6668L3.75732 6.42411L4.69999 5.48145L7.99999 8.78145Z" fill={fill}/>
      </g>
      <defs>
        <clipPath id="clip0_4884_29">
          <rect width={width} height={height} fill={fill}/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default ArrowCaretDownIcon
